import { useSearchParams } from "react-router";

import { getPowerBiConfigs } from "@/config/environmentUtils";

const PowerBI = ({ title = "" }) => {
  const [searchParams] = useSearchParams();
  const { ctid, defaultReportID } = getPowerBiConfigs();

  const reportId = searchParams.get("report_id") || defaultReportID;

  const src = `https://app.powerbi.com/reportEmbed?reportId=${reportId}&autoAuth=true&ctid=${ctid}`;

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <iframe
        title={title}
        style={{
          flexGrow: "1",
          border: "none",
          margin: "0",
          padding: "0",
        }}
        src={src}
        frameBorder="0"
        allowFullScreen={true}
      ></iframe>
    </div>
  );
};

export default PowerBI;
